import clickOutside from "../helpers/click-outside";

const nav = document.querySelector(".js-nav");
const navControls = document.querySelectorAll(".js-nav-control");
const navItems = document.querySelectorAll(".js-nav-item");

navControls.forEach(navControl => {
    navControl.addEventListener("click", () => {
        nav.classList.toggle("m-menu--open");
    });
});

navItems.forEach(navItem => {
    const navLink = navItem.querySelector(".menu__link");

    navLink.addEventListener("click", (e) => {
        e.preventDefault();
        hideNav();
        showNav(navItem);
        clickOutside(".js-nav-item", hideNav);
    });
});

function showNav(navItem) {
    const navLink = navItem.querySelector(".menu__link");
    // set current to active
    navLink.classList.add("menu__link--active");
    // find sub nav
    const subNav = navItem.querySelector(".js-sub-nav");
    if (subNav) {
        // show sub nav
        subNav.classList.add("menu__box--open");
    }
    // add overlay class
    document.body.classList.add("nav-open");
};

function hideNav() {
    navItems.forEach(navItem => {
        const navLink = navItem.querySelector(".menu__link");
        // remove active class
        navLink.classList.remove("menu__link--active");
        // find sub nav
        const subNav = navItem.querySelector(".js-sub-nav");
        if (subNav) {
            // hide sub nav
            subNav.classList.remove("menu__box--open");
        }
    });
    // remove overlay class
    document.body.classList.remove("nav-open");
};